export const IosInstallModal = ({ open, onClose }) => {
  if (!open) {
    return null;
  }

  return (
    <div
      className="ios-install-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ios-install-modal-title"
    >
      <button
        type="button"
        className="ios-install-modal__backdrop"
        aria-label="Закрити"
        onClick={onClose}
      />
      <div className="ios-install-modal__sheet">
        <p id="ios-install-modal-title" className="ios-install-modal__text">
          На iPhone: відкрийте сайт у Safari, натисніть «Поділитися», потім «На
          Початковий екран».
        </p>
        <button
          type="button"
          className="ios-install-modal__close"
          onClick={onClose}
        >
          Закрити
        </button>
      </div>
    </div>
  );
};
